import React from 'react';

const RequiredFieldIndicator = () => {
    return (
        <span style={{'color': 'red', 'paddingLeft': '3px', 'paddingRight': '3px'}}>*</span>
    );
};

export default RequiredFieldIndicator;